import gql from 'graphql-tag.macro';

const query = gql`
  mutation destroyUserSession($application: String) {
    destroyUserSession(application: $application) {
      status
    }
  }
`;

export const destroyUserSession = {
  query,
};
